import "./Header.css";

import {useData, getRootUrl, getBkendUrl } from "../../consts.js";
import { useTblInfo, handleLogout } from "../../axios_with_token.js";

import { useState } from "react";
import { Navigate  } from "react-router-dom";

// import Cookies from 'js-cookie';
import { Link, useNavigate } from "react-router-dom";
import { useLoginContext } from "../../Login/Login.jsx";


const rootUrl = getRootUrl();
export default function Header(props){
    const navigate = useNavigate();
    const [redirectTo, setRedirectTo] = useState('');
    // https://www.reddit.com/r/node/comments/1blqlhn/please_help_i_am_going_absolutely_crazy_axios/
    // https://stackoverflow.com/questions/38114403/remove-cookie-problems-js-cookie
    // const {setLoggedIn, userInfo} = useData();
    // const {getUserInfo} = useLogin({});
    const {logout, userInfo} = useLoginContext();


    const {data:tblInfo, loading:tblListLoading, error:tblListError} = useTblInfo();
    {
        const loading = tblListLoading;

        const error = [];
        [tblListError].filter(a=>a).map(errs=>(errs.constructor==Array?errs:[]).filter(a=>a).map(err=>{error.push(err.message)}));

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error.length > 0) {
            return <div>Error: {error.map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
        }
    }

    // const { logout } = handleLogout();

    const hideAfterClick = evt=>{
        // evt.preventDefault();
        // evt.stopPropagation();
        // return;
        const menu = evt.target.closest(".dropdown-menu");
        menu.style.top = "1000000px";
        setTimeout(_=>menu.style.top = "auto",100);
        evt.target.blur();
    }

    const tblNames = Object.keys(tblInfo||{});
    // const rowMax = 15;

    const admin_inventory = {
        useCol: false,
        items: [
            {
                caption: 'Inventory Check',
                to: `${rootUrl}/app2/manage/inventory/inventoryChk`
            },
            {
                caption: 'Inventory check2',
                to: `${rootUrl}/app2/manage/inventory/inventoryChk2`
            },
            {
                caption: 'Inventory verify',
                to: `${rootUrl}/app2/manage/inventory/inventoryVerify`
            },
            {
                caption: 'product check',
                to: `${rootUrl}/app2/manage/inventory/ProductChk`
            },
            {
                caption: 'Clear products without records',
                to: `${rootUrl}/app2/manage/inventory/CombinePdts`
            },
            {
                caption: 'Inventory History',
                to: `${rootUrl}/app2/manage/inventory/inventoryHistory`
            }

        ]
    };

    return <>
        {redirectTo && <Navigate to={redirectTo} />}
        <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light text-nowrap">
            <div className="container-fluid">
                <a className="navbar-brand" href="#">Manage</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li key="Home" className="nav-item">
                        <Link
                            className="nav-link active" aria-current="page" 
                            to={`${rootUrl}/app2/manage`}
                        >Home</Link>
                    </li>
                    <li key="BBS" className="nav-item">
                        <a className="nav-link" href={rootUrl+"/app2/manage/BBS"}>BBS</a>
                    </li>

                    {/* processes */}
                    <li key="Processes" className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Processes
                        </a>
                        <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                            <Link 
                                tabIndex={"1"}
                                className="nav-link text-nowrap" 
                                onClick={hideAfterClick}
                                to={`${rootUrl}/app2/manage/processes/salesOrder`} 
                            >sales order</Link>
                            <Link 
                                tabIndex={"1"}
                                className="nav-link text-nowrap" 
                                onClick={hideAfterClick}
                                to={`${rootUrl}/app2/manage/processes/purchaseOrder`} 
                            >purchase order</Link>
                            <Link 
                                tabIndex={"1"}
                                className="nav-link text-nowrap" 
                                onClick={hideAfterClick}
                                to={`${rootUrl}/app2/manage/processes/sampleRequest`} 
                            >sample request</Link>
                        </ul>  

                    </li>

                    {/* admin */}
                    <li key="admin" className="nav-item dropdown"                    
                    >
                        <a className="nav-link dropdown-toggle" href="#" id="id-admin" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            admin
                        </a>
                        <ul className="dropdown-menu"
                            aria-labelledby="id-admin d-relative">
                            
                            {/* admin / tables */}
                            <li key="admin-tables" className=""
                            >
                                <a tabIndex="1" 
                                    className="dropdown-item submenu" 
                                    href="#" 
                                    id="id-tables"
                                    role="button"
                                    aria-expanded="false"
                                    data-bs-toggle="dropdown"
                               >
                                    Tables
                                </a>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="id-tables d-relative"
                                >
                                    <div className="row d-flex"
                                        style={{
                                            "width":'50vw',
                                            "maxHeight": '50vh',
                                            overflow: 'scroll',
                                            margin: '0'
                                        }}
                                    >
                                        {
                                            tblNames.map((tblName, idx)=><Link 
                                                    tabIndex={"1"}
                                                    key={"tblname-"+idx}
                                                    className="nav-link col-md-3 mx-3" 
                                                    onClick={hideAfterClick}
                                                    to={`${rootUrl}/app2/manage/Tbl/${tblName}`}  
                                                >{tblName}</Link>
                                            )
                                        }
                                    </div>

                                </div>
                            </li>

                            {/* admin / inventory */}
                            <li key="admin-inventory" className=""
                            >
                                <a tabIndex="1" 
                                    className="dropdown-item submenu" 
                                    href="#" 
                                    id="id-inventory"
                                    role="button" 
                                    aria-expanded="false"
                                    data-bs-toggle="dropdown"
                               >
                                    Inventory
                                </a>
                                <div className="dropdown-menu"
                                    aria-labelledby="id-inventory"
                                >
                                    <div className="row p-3">
                                        {admin_inventory.items.map((mItemDef, mItemIdx)=>{
                                            return <Link
                                                key={`${mItemDef.caption}-${mItemIdx}`}
                                                tabIndex={"1"}
                                                className={["nav-link", admin_inventory.useCol?'col':''].filter(a=>a).join(' ')} 
                                                onClick={hideAfterClick}
                                                to={mItemDef.to}
                                                // style={{clear:"both"}}
                                            >{mItemDef.caption}</Link>
                                        })}

                                        {/* <Link 
                                            tabIndex={"1"}
                                            className="nav-link col" 
                                            to={`${rootUrl}/app2/manage/inventory/inventoryChk`} 

                                        >Inventory Check</Link>
                                                
                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link col" 
                                            to={`${rootUrl}/app2/manage/inventory/CombinePdts`} 

                                        >Clear products without records</Link>

                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link col" 
                                            to={`${rootUrl}/app2/manage/inventory/inventoryHistory`} 

                                        >Inventory History</Link> */}

                                    </div>

                                </div>
                            </li>
                            
                            {/* admin / database */}
                            <li key="admin-database" className=""
                            >
                                <a tabIndex="1" 
                                    className="dropdown-item submenu" 
                                    href="#" 
                                    _id="navbarDropdown" role="button" _aria-expanded="false"
                               >
                                    database
                                </a>
                                <div className="dropdown-menu" >
                                    <div className="row p-3">
                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/db/tblDesign`} 
                                        >table design</Link>
                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/db/tblLogs`} 
                                        >table logs</Link>
                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/db/tools`} 
                                        >tools</Link>
                                    </div>
                               </div>

                            </li>

                            {/* admin / settings */}
                            <li key="admin-settings" className=""
                            >
                                <a tabIndex="1" 
                                    className="dropdown-item submenu" 
                                    href="#" 
                                    _id="navbarDropdown" role="button" _aria-expanded="false"
                               >
                                    settings
                                </a>
                                {/* admin / users */}
                                {/* <li key="admin-users"
                                    className=""
                                >
                                    <a href="#"
                                        onClick={hideAfterClick}
                                        className="dropdown-item"
                                >Users</a>
                                </li> */}

                                <div className="dropdown-menu">
                                    <div className="row p-3">
                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/settings/usersSettings`} 
                                        >users and roles</Link>

                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/settings/menuSettings`} 
                                        >menu and permission</Link>

                                        <Link 
                                            tabIndex={"1"}
                                            className="nav-link row px-3" 
                                            onClick={hideAfterClick}
                                            to={`${rootUrl}/app2/manage/settings/urlsSettings`} 
                                        >urls</Link>


                                    </div>
                               </div>

                            </li>
                            
                        </ul>  
                    </li>

                    {/* ------------------ */}

                    {/* <li className="nav-item dropdown" id="myDropdown">
                        <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">  Treeview menu  </a>
                        <ul className="dropdown-menu">
                            <li> <a className="dropdown-item" href="#"> Dropdown item 1 </a></li>
                            <li> 
                                <label htmlFor="aaa">Dropdown item 2 &raquo;

                                    <input type="checkbox" id="aaa" style={{"display": "none"}}/>
                                </label>
                                <a className="dropdown-item" href="#"> Dropdown item 2 &raquo; </a>
                            <ul className="submenu dropdown-menu">
                                <li><a className="dropdown-item" href="#">Submenu item 1</a></li>
                                <li><a className="dropdown-item" href="#">Submenu item 2</a></li>
                                <li><a className="dropdown-item" href="#">Submenu item 3 &raquo; </a>
                                <ul className="submenu dropdown-menu">
                                    <li><a className="dropdown-item" href="#">Multi level 1</a></li>
                                    <li><a className="dropdown-item" href="#">Multi level 2</a></li>
                                </ul>
                                </li>
                                <li><a className="dropdown-item" href="#">Submenu item 4</a></li>
                                <li><a className="dropdown-item" href="#">Submenu item 5</a></li>
                            </ul>
                            </li>
                            <li><a className="dropdown-item" href="#"> Dropdown item 3 </a></li>
                            <li><a className="dropdown-item" href="#"> Dropdown item 4 </a></li>
                        </ul>
                    </li> */}


                    {/* -------------------- */}
                    {/* <li className="nav-item">
                        <a className="nav-link disabled" href="#" tabIndex="-1" aria-disabled="true">Disabled</a>
                    </li> */}
                    {/* <li className="nav-item">
                    </li> */}
                </ul>
                <span className="mx-2">[ {getBkendUrl()} ]</span>
                <form className="d-flex">
                    <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                    <button className="btn btn-outline-success" type="submit">Search</button>
                </form>
                <a className="nav-link text-nowrap mx-2"
                    href={"#"}
                    onClick={evt=>{
                        logout(); 
                    }}
                >Log out ({(userInfo||{}).user_name}) </a>
                </div>
            </div>
        </nav>
        <div style={{"height":"5em"}}></div>
    </>;
}